import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { LogOut, Phone, Mail, FileText, Package } from "lucide-react";
import SEO from "@/components/SEO";

export default function DealerPortal() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const doLogout = async () => {
    await logout();
    nav("/bayi-girisi");
  };

  return (
    <>
      <SEO title="Bayi Panel" description="Wünberg Bayi Portalı" />
      <section className="pt-28 pb-24">
        <div className="wb-container">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-8 border-b border-white/10">
            <div>
              <div className="wb-overline">Bayi Paneli</div>
              <h1 className="wb-h2 mt-2">Hoş geldin, <span className="text-[#d4af37]">{user?.name || user?.email}</span></h1>
              <div className="text-sm text-[#a0aabf] mt-2">{user?.company || ""}</div>
            </div>
            <button onClick={doLogout} className="wb-btn-secondary" data-testid="dealer-logout">
              <LogOut size={16} /> Çıkış
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
            <div className="wb-card p-8">
              <Package className="text-[#d4af37]" size={28} />
              <div className="font-serif text-xl mt-4">Ürün Kataloğu</div>
              <p className="text-sm text-[#a0aabf] mt-2">Güncel ürün listesi ve teknik bilgileri.</p>
              <Link to="/urunler" className="wb-btn-secondary mt-5 inline-flex" data-testid="dealer-products-link">İncele</Link>
            </div>
            <div className="wb-card p-8">
              <FileText className="text-[#d4af37]" size={28} />
              <div className="font-serif text-xl mt-4">Fiyat Listesi</div>
              <p className="text-sm text-[#a0aabf] mt-2">Bayi özel iskonto ve fiyat listesi için bizimle iletişime geçin.</p>
              <a href="mailto:info@cebitech.com.tr" className="wb-btn-secondary mt-5 inline-flex">E-posta Gönder</a>
            </div>
            <div className="wb-card p-8">
              <Phone className="text-[#d4af37]" size={28} />
              <div className="font-serif text-xl mt-4">Bayi Destek</div>
              <p className="text-sm text-[#a0aabf] mt-2">Sipariş ve teslimat için doğrudan bayi destek hattı.</p>
              <a href="tel:+905442226107" className="wb-btn-secondary mt-5 inline-flex">Ara</a>
            </div>
          </div>

          <div className="mt-10 wb-glass p-8">
            <div className="wb-overline">Bilgilendirme</div>
            <p className="wb-body mt-3">
              Bu portalda yakında: online sipariş, fatura geçmişi, kampanya
              materyalleri ve sertifika belgeleri yer alacak. Acil sipariş ve
              sorularınız için <a href="mailto:info@cebitech.com.tr" className="text-[#d4af37] underline">info@cebitech.com.tr</a>.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
